/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-var */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */
import Web3 from 'web3';
import axios from 'axios';
import { ENVIRONMENT } from 'configs';
import NFTContract from 'configs/abis/NFTMarketplace.json';
import toast from 'react-hot-toast';

var web3 = new Web3(
  Web3.givenProvider || 'ws://some.local-or-remote.node:8546'
);
//
export const getAllAdmins = async () => {
  const contract = new web3.eth.Contract(
    NFTContract.abi,
    ENVIRONMENT.CONTRACT_ADDRESS
  );
  const items = await contract.methods.getAllAdmins().call();
  const allAdmins = await Promise.all(
    items.map(async (i) => {
      if (i.adminDetails) {
        const { data } = await axios.get(
          `https://ipfs.io/ipfs/${i.adminDetails}`
        );
        return {
          id: i.adminId,
          name: data.name,
          wallet: i.wallet,
          email: data.email,
          image: data?.image,
        };
      }
      return null;
    })
  );
  return allAdmins;
};

export const deleteAdmin = async (data) => {
  const account = await web3.eth.getAccounts();
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    // const address = await web3.eth.getAccounts();
    const res = await contract.methods
      .removeAdmin(data)
      .send({ from: account[0] });
    return res;
  }
  return toast('Connect your wallet before add an admin.', {
    position: 'bottom-center',
    icon: '⚠️',
  });
};

export const getMasterAdmin = async () => {
  const account = await web3.eth.getAccounts();
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    // const address = await web3.eth.getAccounts();
    const res = await contract.methods.getMasterAdmin().call();
    return res;
  }
  return {};
  // return toast('Connect your wallet before add an admin.', {
  //   position: 'bottom-center',
  //   icon: '⚠️',
  // });
};

export const changeMasterAdmin = async (data) => {
  const account = await web3.eth.getAccounts();
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    const res = await contract.methods
      .changeMaster(data)
      .send({ from: account[0] });
    return res;
  }
  return toast('Connect your wallet before add an admin.', {
    position: 'bottom-center',
    icon: '⚠️',
  });
};
